import { render, staticRenderFns } from "./ownerPostComponent.vue?vue&type=template&id=c805f7b4&scoped=true"
import script from "./ownerPostComponent.vue?vue&type=script&lang=js"
export * from "./ownerPostComponent.vue?vue&type=script&lang=js"
import style0 from "./ownerPostComponent.vue?vue&type=style&index=0&id=c805f7b4&prod&lang=css"
import style1 from "./ownerPostComponent.vue?vue&type=style&index=1&id=c805f7b4&prod&scoped=true&lang=css"
import style2 from "./ownerPostComponent.vue?vue&type=style&index=2&id=c805f7b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c805f7b4",
  null
  
)

export default component.exports